import KeepLink from './KeepLink';
import type { ThemeEntry } from '../data/types';
import type { Lang } from '../hooks/useLang';
import './ThemeChips.css';

interface Props {
    tags: string[];
    themes: ThemeEntry[];
    lang: Lang;
}

export default function ThemeChips({ tags, themes, lang }: Props) {
    const bySlug = new Map(themes.map((t) => [t.slug, t]));
    return (
        <ul className="theme-chips" aria-label="Themes on this kural">
            {tags.map((tag) => {
                const theme = bySlug.get(tag);
                if (!theme) return null;
                return (
                    <li key={tag} className="theme-chips__item">
                        <KeepLink to={`/theme/${tag}`} className="theme-chips__link">
                            {lang === 'ta' ? (
                                <>
                                    <span lang="ta" className="theme-chips__lead">
                                        {theme.title_ta}
                                    </span>
                                    <span className="theme-chips__sub">{theme.title_en}</span>
                                </>
                            ) : (
                                <>
                                    <span className="theme-chips__lead">{theme.title_en}</span>
                                    <span lang="ta" className="theme-chips__sub">
                                        {theme.title_ta}
                                    </span>
                                </>
                            )}
                        </KeepLink>
                    </li>
                );
            })}
        </ul>
    );
}
